import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from '../Navbar'
import Search from '../Search'
import Featured from '../Featured'
import CategorySearch from '../CategorySearch'
import Footer from '../Footer'
import Footer2 from '../Footer2'
import Carousel from '../Carousel'

const Home = () => {

  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
    //eslint-disable-next-line
  }, []);

  const slides = [
    { image: 'https://savyour.com.pk/products/wp-content/uploads/2023/03/Bleu-De-Chanel-OG-Banner.jpg.jpg', caption: 'Slide 1' },
    { image: 'https://cdn.theluxurycloset.com/uploads/home/1578478044-Hero-Banner-960x552-LV.jpg', caption: 'Slide 2' },
    { image: 'https://www.dubaidutyfree.com/file/general/GUCCI_TOP_BANNER_2.jpg', caption: 'Slide 3' },
    { image: 'https://images.squarespace-cdn.com/content/v1/58e9b976e58c6214d4b74edc/1588646877386-993LXU0L0I470KZK4PX1/Banner-with+logo.jpg?format=2500w', caption: 'Slide 4' },
    { image: 'https://www.boat-lifestyle.com/cdn/shop/articles/Banner_2_1280x.png?v=1653120525', caption: 'Slide 5' },
    { image: 'https://www.jumpplus.com/web/image/835564/MacBook_Pro_13_in_Web_Banner_1400x700__caEN_Simp.jpg?access_token=57c102a8-266b-4033-8aea-76072943955e', caption: 'Slide 6' },
    { image: 'https://images.vexels.com/content/126443/preview/macbook-pro-touch-bar-banner-fedf81.png', caption: 'Slide 7' },
    { image: 'https://cdn.tgdd.vn/Files/2021/10/19/1391493/cach-tai-hinh-nen-macbook-pro-14-inch-va-macbook-pro-16-inch_1280x720-800-resize.jpg', caption: 'Slide 8' },
    { image: 'https://static.lenovo.com/cap/Slim-7-Carbon-landing/images/v2/banner01-bg.jpg', caption: 'Slide 9' },
    { image: 'https://www.birdsofparadyes.com/cdn/shop/files/share_dd8f062e-90d6-4e20-b17e-90c33f91f47b.png?v=1618403300', caption: 'Slide 10' },
  ];

  return (
    <>
    <Navbar/>
    <Search/>
    <Carousel slides={slides} />
    <Featured/>
    <CategorySearch/>
    <Footer/>
    <Footer2/>
    </>
  )
}

export default Home